var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130,120.62l27.87-10.12m-31.29.73,27.86-10.12m-31.29.74L151,91.72M119.91,93l27.87-10.12m-31.3.73,27.88-10.13m-71.1,67.8,27.87-10.12m-31.29.73,27.87-10.12m-31.3.74,27.87-10.13m-31.12,1.23L91,103.43m-31.3.74L87.62,94.05m37.74,59.6c-3.61-9.88,4-12.1,4-12.1l48.75-17.71L151.65,51.2,102.9,68.91s-7.65,2.22-4,12.1Zm0,0c-3.61-9.89-10.9-6.68-10.9-6.68l-48.75,17.7L39.19,92.05,87.94,74.34S95.23,71.13,98.83,81Zm0,0c-3.61-9.89-10.9-6.68-10.9-6.68l-48.75,17.7L39.19,92.05,87.94,74.34S95.23,71.13,98.83,81ZM154.72,59.6l8.79-3.2L190.35,130,59.86,177.39l-27.2-74.57,8.71-3.17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/BOOK.aa34d6bb19821352a1ee4043846f7abb.svg";
export { ForwardRef as ReactComponent };